import React, { memo, useState } from 'react';
import Select from '../CustomSelect';
import constant from 'lodash/constant';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const AutoComplete = ({
    value,
    placeholder,
    label,
    onChange,
    options: _options = [],
    loading = false,
    isSearchable = true,
    onInputChangeAction = () => { },
    resetAction = () => { },
    ...resp
}) => {

    const [options, setOptions] = useState([]);

    const { t } = useTranslation('home');

    const handleFilterOption = constant(true);

    const handleNoOptionsMessage = () => t("home:there_are_no_records_to_show");

    const handleInputChange = newValue => {
        if (newValue && newValue.length > 0) {
            onInputChangeAction(newValue);
        }
    };

    const handleFocus = () => {
        if (value.value !== null && options.findIndex(option => option.value === value.value) === -1) {
            setOptions([
                ..._options,
                value
            ]);
        }
    };

    const handleBlur = () => resetAction();

    useEffect(() => {
        setOptions(_options);
    }, [_options])

    return (
        <Select
            placeholder={placeholder}
            options={options}
            isSearchable={isSearchable}
            onChange={onChange}
            value={value}
            loading={loading}
            onFocus={handleFocus}
            onInputChange={handleInputChange}
            onBlur={handleBlur}
            filterOption={handleFilterOption}
            noOptionsMessage={handleNoOptionsMessage}
            label={label}
            {...resp}
        />
    );
}

export default memo(AutoComplete);